import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";
import { getSessionId } from "./authService";

const UPGRADE_OPTIONS_PATH = "/api/agent/subscription/upgrade-options";
const UPGRADE_PACKAGE_PATH = "/api/agent/subscription/upgrade-package";

function upgradeOptionsUrl() {
  return resolveApiUrl(UPGRADE_OPTIONS_PATH);
}

function upgradePackageUrl() {
  return resolveApiUrl(UPGRADE_PACKAGE_PATH);
}

/**
 * חבילה נוכחית + חבילות יעד לשדרוג (SSOT מהשרת).
 * @returns {Promise<object>}
 */
export async function getAgentSubscriptionUpgradeOptions() {
  const sessionID = await getSessionId();
  if (!sessionID) throw new Error("agent_upgrade_no_session");
  const sid = String(sessionID).trim();
  const { data } = await axios.get(upgradeOptionsUrl(), {
    headers: { "X-Session-ID": sid },
    withCredentials: true,
    timeout: 25000,
  });
  return data;
}

/**
 * @param {{ target_package_code: string, effective_from?: string }} body
 */
export async function postAgentSubscriptionUpgradePackage(body) {
  const sessionID = await getSessionId();
  if (!sessionID) throw new Error("agent_upgrade_no_session");
  const sid = String(sessionID).trim();
  const payload = {
    sessionID: sid,
    target_package_code: body.target_package_code,
    effective_from: body.effective_from ?? "start_of_current_month",
  };
  if (body.applyReferrerStandingCredit === true) {
    payload.applyReferrerStandingCredit = true;
    payload.referredPaidPackageCode = body.referredPaidPackageCode || null;
    payload.creditKind = body.creditKind || "standing_monthly";
  }
  const { data } = await axios.post(
    upgradePackageUrl(),
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        "X-Session-ID": sid,
      },
      withCredentials: true,
      timeout: 40000,
    }
  );
  return data;
}
